import '@banno/jha-wc/src/progress/jha-progress/jha-progress.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../../tm-base.component';

const tagName = 'tm-jh-progress';
@customElement(tagName)
export class TmProgress extends TmBaseComponent {
    @property({ type: Boolean, reflect: true })
    public card = false;

    @property({ type: Boolean, reflect: true })
    public inline = false;

    protected render() {
        return html`<jha-progress id="jha-progress"></jha-progress>`;
    }

    protected updated() {
        const progressElement = this.renderRoot.querySelector('#jha-progress');
        if (progressElement) {
            progressElement.removeAttribute('inline');
            progressElement.removeAttribute('card');
            if (this.inline) {
                progressElement.setAttribute('inline', '');
            }
            if (this.card) {
                progressElement.setAttribute('card', '');
            }
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmProgress;
    }
}
